import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from 'graphql-tag';
import { useIntl } from 'react-intl';
import { OVERRIDE_DIMENSION_PROPS } from './enum';

export const GET_PROJECT_COST_RATE_TABLE_DIMENSIONS = gql`
  query getProjectCostRateTableDimensions($projectId: String!) {
    project(projectId: $projectId) {
      id
      costRateTableDimension {
        dimensions {
          id
          displayText
          slug
          objectType
        }
        requiredDimensions {
          id
          displayText
          slug
          objectType
        }
      }
    }
  }
`;

export const useCostOverrideTableDimensions = ({ projectId } = {}) => {
  const intl = useIntl();
  const { data, loading } = useQuery(GET_PROJECT_COST_RATE_TABLE_DIMENSIONS, {
    variables: { projectId },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network'
  });

  const { dimensions, requiredDimensions } =
    data?.project?.costRateTableDimension || {};

  const projectDimensions = useMemo(
    () =>
      (dimensions || []).map(d => {
        const override = OVERRIDE_DIMENSION_PROPS[d.slug];

        return { ...d, ...(override ? override(intl) : {}) };
      }),
    [dimensions, intl]
  );

  return {
    loading: loading && !data,
    projectDimensions,
    requiredDimensions: requiredDimensions || []
  };
};

export default useCostOverrideTableDimensions;
